const ipAddress = 'https://pr2backend.arlevin.org';

export default ipAddress;
